import { SelectOption } from '@frontend/components/basic-forms';
import { FeatureTarget } from '@frontend/functionality/types';
import { useMemo } from 'react';
import { FeatureTargetSelectProps } from './feature-target-select.component';

interface ViewProps {
    options: SelectOption<FeatureTarget>[];
}

const useFeatureTargetSelect = (props: FeatureTargetSelectProps): ViewProps => {
    const options = useMemo<SelectOption<FeatureTarget>[]>(() => {
        return Object.values(FeatureTarget)
            .filter((target) => !props.subset || props.subset.includes(target))
            .map((target) => ({
                label: target,
                value: target,
                icon: target,
                display: target
            }));
    }, [props.subset]);

    return { options };
};

export default useFeatureTargetSelect;
